import { TStepCompletionStatus, THostRoomProgress } from '@/entities/room'

export const STEPS: {
  key: keyof TStepCompletionStatus
  label: string
  value: number
}[] = [
  { key: 'spaceInfo', label: '공간', value: 0 },
  { key: 'feeInfo', label: '임대료', value: 1 },
  { key: 'options', label: '옵션', value: 2 },
  { key: 'description', label: '방 설명', value: 3 },
  { key: 'contractPolicy', label: '일정', value: 4 },
] as const

export const getUpdatableLastStep = ({
  stepCompletionStatus,
  requiredFieldsCompleted,
}: Omit<THostRoomProgress, 'roomStatus'>) => {
  if (requiredFieldsCompleted) {
    return STEPS.length - 1
  }

  const lastStep = STEPS.findIndex(({ key }) => !stepCompletionStatus[key])

  return lastStep === -1 ? STEPS.length - 1 : lastStep
}

export const getStepQuery = (step: number) => {
  return step + 1
}
